import { BUNDLE_SUCCESS, BundleAction } from './types';
import { BundleOut } from '../api';

export const receiveBundle = (bundle: BundleOut): BundleAction => {
    return {
        type: BUNDLE_SUCCESS,
        payload: bundle
    };
};
